import React, {Component} from 'react';
import {withRouter, Route, Switch} from 'react-router-dom';
import Helmet from 'react-helmet';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';

import Loader from 'components/Loader';
import {nodeId} from 'libs/react-widgets';

import {getSettings} from '../actions/settings';
import Markdown from 'components/Markdown';
import {renderRoutes, NotFoundPage, COMPONENT_MAPPING} from './routes-helper';
import {initializeCookieBanner, getCookieBannerStyles} from '../services/cookieBanner';
import ToastMessage from '../components/ToastMessage';
import {TrackingProvider} from '../services/analytics/TrackingContext';

export class AppRoutes extends Component {
  constructor(props) {
    super(props);

    const url = window.location.href;
    const isProduction = /policyacumen\.health/g.test(url);
    const isStaging = /stg\.policyacumen\.us/g.test(url);
    const isLocal = /localhost/g.test(url);
    let subdomains = isLocal ? window.env.hasOwnProperty('subdomain') ? [window.env.subdomain, '', '']
      : []
      : window.location.host.split('.');

    if (subdomains.length > 2) {
      this.props.dispatchGetSettings(subdomains[0]);
    }

    this.state = {
      isGoogleMetricsInitialized: false,
      isProduction,
      isStaging,
      isLocal,
      alert: ''
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isGoogleMetricsInitialized && !this.state.isGoogleMetricsInitialized &&
      this.props.settings && (this.props.settings.analyticsId || this.props.settings.gtm)) {
      this.initializeReactGA(this.state.isProduction, this.props.settings.analyticsId, this.props.settings.testMode);
      for (const gtm of this.props.settings.gtm || []) {
        this.initializeReactGTM(this.state.isProduction, gtm);
      }
      this.setState({isGoogleMetricsInitialized: true});
    }

    if (this.props.settings.redirect && this.props.settings.redirect !== prevProps.settings.redirect) {
      if (this.state.isLocal) {
        this.props.dispatchGetSettings(this.props.settings.redirect);
      } else {
        let urlArray = window.location.href.split('.');
        urlArray.shift();
        window.location.href = `${window.location.protocol}//${this.props.settings.redirect}.${urlArray.join('.')}`;
      }
    }

    // Handle cookie banner initialization and handler attachment
    // Re-attaches handlers on route changes (idempotent)
    initializeCookieBanner(this.props.settings, prevProps.settings, (message, error) => {
      this.setState({alert: message});
      if (window.Rollbar) {
        window.Rollbar.error(message, error);
      }
    });
  }


  initializeReactGA(isProduction, analyticsId, test) {
    if (isProduction && analyticsId) {
      ReactGA.initialize(analyticsId, {
        testMode: test ? true : false,
      });
    }
  }

  initializeReactGTM(isProduction, gtm) {
    if (isProduction && gtm) {
      // gtm object only accepts parameters defined in https://www.npmjs.com/package/react-gtm-module.
      TagManager.initialize({...gtm});
    }
  }

  //TODO: refactor and move this meta wrapper out of the router.jsx
  getMetaWrapper(settings, isLocal, isProduction) {
    let headElements = [];

    settings.responsiveness ? headElements.push(<meta key={nodeId()} name='viewport' content='width=device-width, initial-scale=1, shrink-to-fit=no'/>) : headElements.push(<meta key={nodeId()} name='viewport' content='width=1280'/>);

    if (!isLocal) {
      let dynamicDomainsConfig = `transform: function(payload) {var trace = payload.body.trace; var locRegex = /^(https?):\\/\\/[a-zA-Z0-9._-]+\\.policyacumen\\.${isProduction ? 'health' : 'us'}(.*)/; if (trace && trace.frames) {for (var i = 0; i < trace.frames.length; i++) {var filename = trace.frames[i].filename; if (filename) {var m = filename.match(locRegex); trace.frames[i].filename = m[1] + '://dynamichost' + m[2];}}}}`;

      headElements.push(
        <script key={nodeId()}>
          {`var _rollbarConfig = {${dynamicDomainsConfig}, accessToken: "${window.env.rollbarToken}",captureUncaught: true,captureUnhandledRejections: true,payload: {client: {javascript: {source_map_enabled: true, code_version: '${window.env.version}'}}, environment: window.location.href,framework: "react",}};!function(r){function e(n){if(o[n])return o[n].exports;var t=o[n]={exports:{},id:n,loaded:!1};return r[n].call(t.exports,t,t.exports,e),t.loaded=!0,t.exports}var o={};return e.m=r,e.c=o,e.p="",e(0)}([function(r,e,o){"use strict";var n=o(1),t=o(4);_rollbarConfig=_rollbarConfig||{},_rollbarConfig.rollbarJsUrl=_rollbarConfig.rollbarJsUrl||"https://cdnjs.cloudflare.com/ajax/libs/rollbar.js/2.4.1/rollbar.min.js",_rollbarConfig.async=void 0===_rollbarConfig.async||_rollbarConfig.async;var a=n.setupShim(window,_rollbarConfig),l=t(_rollbarConfig);window.rollbar=n.Rollbar,a.loadFull(window,document,!_rollbarConfig.async,_rollbarConfig,l)},function(r,e,o){"use strict";function n(r){return function(){try{return r.apply(this,arguments)}catch(r){try{console.error("[Rollbar]: Internal error",r)}catch(r){}}}}function t(r,e){this.options=r,this._rollbarOldOnError=null;var o=s++;this.shimId=function(){return o},"undefined"!=typeof window&&window._rollbarShims&&(window._rollbarShims[o]={handler:e,messages:[]})}function a(r,e){if(r){var o=e.globalAlias||"Rollbar";if("object"==typeof r[o])return r[o];r._rollbarShims={},r._rollbarWrappedError=null;var t=new p(e);return n(function(){e.captureUncaught&&(t._rollbarOldOnError=r.onerror,i.captureUncaughtExceptions(r,t,!0),i.wrapGlobals(r,t,!0)),e.captureUnhandledRejections&&i.captureUnhandledRejections(r,t,!0);var n=e.autoInstrument;return e.enabled!==!1&&(void 0===n||n===!0||"object"==typeof n&&n.network)&&r.addEventListener&&(r.addEventListener("load",t.captureLoad.bind(t)),r.addEventListener("DOMContentLoaded",t.captureDomContentLoaded.bind(t))),r[o]=t,t})()}}function l(r){return n(function(){var e=this,o=Array.prototype.slice.call(arguments,0),n={shim:e,method:r,args:o,ts:new Date};window._rollbarShims[this.shimId()].messages.push(n)})}var i=o(2),s=0,d=o(3),c=function(r,e){return new t(r,e)},p=d.bind(null,c);t.prototype.loadFull=function(r,e,o,t,a){var l=function(){var e;if(void 0===r._rollbarDidLoad){e=new Error("rollbar.js did not load");for(var o,n,t,l,i=0;o=r._rollbarShims[i++];)for(o=o.messages||[];n=o.shift();)for(t=n.args||[],i=0;i<t.length;++i)if(l=t[i],"function"==typeof l){l(e);break}}"function"==typeof a&&a(e)},i=!1,s=e.createElement("script"),d=e.getElementsByTagName("script")[0],c=d.parentNode;s.crossOrigin="",s.src=t.rollbarJsUrl,o||(s.async=!0),s.onload=s.onreadystatechange=n(function(){if(!(i||this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState)){s.onload=s.onreadystatechange=null;try{c.removeChild(s)}catch(r){}i=!0,l()}}),c.insertBefore(s,d)},t.prototype.wrap=function(r,e,o){try{var n;if(n="function"==typeof e?e:function(){return e||{}},"function"!=typeof r)return r;if(r._isWrap)return r;if(!r._rollbar_wrapped&&(r._rollbar_wrapped=function(){o&&"function"==typeof o&&o.apply(this,arguments);try{return r.apply(this,arguments)}catch(o){var e=o;throw e&&("string"==typeof e&&(e=new String(e)),e._rollbarContext=n()||{},e._rollbarContext._wrappedSource=r.toString(),window._rollbarWrappedError=e),e}},r._rollbar_wrapped._isWrap=!0,r.hasOwnProperty))for(var t in r)r.hasOwnProperty(t)&&(r._rollbar_wrapped[t]=r[t]);return r._rollbar_wrapped}catch(e){return r}};for(var u="log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection,captureEvent,captureDomContentLoaded,captureLoad".split(","),f=0;f<u.length;++f)t.prototype[u[f]]=l(u[f]);r.exports={setupShim:a,Rollbar:p}},function(r,e){"use strict";function o(r,e,o){if(r){var t;"function"==typeof e._rollbarOldOnError?t=e._rollbarOldOnError:r.onerror&&!r.onerror.belongsToShim&&(t=r.onerror,e._rollbarOldOnError=t);var a=function(){var o=Array.prototype.slice.call(arguments,0);n(r,e,t,o)};a.belongsToShim=o,r.onerror=a}}function n(r,e,o,n){r._rollbarWrappedError&&(n[4]||(n[4]=r._rollbarWrappedError),n[5]||(n[5]=r._rollbarWrappedError._rollbarContext),r._rollbarWrappedError=null),e.handleUncaughtException.apply(e,n),o&&o.apply(r,n)}function t(r,e,o){if(r){"function"==typeof r._rollbarURH&&r._rollbarURH.belongsToShim&&r.removeEventListener("unhandledrejection",r._rollbarURH);var n=function(r){var o,n,t;try{o=r.reason}catch(r){o=void 0}try{n=r.promise}catch(r){n="[unhandledrejection] error getting \`promise\` from event"}try{t=r.detail,!o&&t&&(o=t.reason,n=t.promise)}catch(r){t="[unhandledrejection] error getting \`detail\` from event"}o||(o="[unhandledrejection] error getting \`reason\` from event"),e&&e.handleUnhandledRejection&&e.handleUnhandledRejection(o,n)};n.belongsToShim=o,r._rollbarURH=n,r.addEventListener("unhandledrejection",n)}}function a(r,e,o){if(r){var n,t,a="EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");for(n=0;n<a.length;++n)t=a[n],r[t]&&r[t].prototype&&l(e,r[t].prototype,o)}}function l(r,e,o){if(e.hasOwnProperty&&e.hasOwnProperty("addEventListener")){for(var n=e.addEventListener;n._rollbarOldAdd&&n.belongsToShim;)n=n._rollbarOldAdd;var t=function(e,o,t){n.call(this,e,r.wrap(o),t)};t._rollbarOldAdd=n,t.belongsToShim=o,e.addEventListener=t;for(var a=e.removeEventListener;a._rollbarOldRemove&&a.belongsToShim;)a=a._rollbarOldRemove;var l=function(r,e,o){a.call(this,r,e&&e._rollbar_wrapped||e,o)};l._rollbarOldRemove=a,l.belongsToShim=o,e.removeEventListener=l}}r.exports={captureUncaughtExceptions:o,captureUnhandledRejections:t,wrapGlobals:a}},function(r,e){"use strict";function o(r,e){this.impl=r(e,this),this.options=e,n(o.prototype)}function n(r){for(var e=function(r){return function(){var e=Array.prototype.slice.call(arguments,0);if(this.impl[r])return this.impl[r].apply(this.impl,e)}},o="log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection,_createItem,wrap,loadFull,shimId,captureEvent,captureDomContentLoaded,captureLoad".split(","),n=0;n<o.length;n++)r[o[n]]=e(o[n])}o.prototype._swapAndProcessMessages=function(r,e){this.impl=r(this.options);for(var o,n,t;o=e.shift();)n=o.method,t=o.args,this[n]&&"function"==typeof this[n]&&("captureDomContentLoaded"===n||"captureLoad"===n?this[n].apply(this,[t[0],o.ts]):this[n].apply(this,t));return this},r.exports=o},function(r,e){"use strict";r.exports=function(r){return function(e){if(!e&&!window._rollbarInitialized){r=r||{};for(var o,n,t=r.globalAlias||"Rollbar",a=window.rollbar,l=function(r){return new a(r)},i=0;o=window._rollbarShims[i++];)n||(n=o.handler),o.handler._swapAndProcessMessages(l,o.messages);window[t]=n,window._rollbarInitialized=!0}}}}]);`}
        </script>
      );
    }

    // Note: to enable smooth scrolling, you may need to visit chrome://flags/#smooth-scrolling or edge://flags/#smooth-scrolling
    headElements.push(
      <style key={nodeId()} type="text/css">{
        `html {
          scroll-behavior: ${settings.page && settings.styles.page && settings.styles.page.scrollBehavior ? settings.styles.page.scrollBehavior : 'auto'} !important;
        }

        body {
          font-family: ${settings.page ? settings.styles.page.font : 'Helvetica Neue,Helvetica,Arial,sans-serif'};
          font-size: ${settings.page ? settings.styles.page.fontSize : '14px'};
          color: ${settings.page ? settings.styles.page.color : '#000000'};
          position: ${settings.page ? settings.styles.page.position : 'static'};
        }

        .tooltip { 
          --bs-tooltip-bg: ${settings.styles?.tooltip?.tooltipArrowColor} !important;
        }

        table {
          --bs-emphasis-color: ${settings.styles.page.color}; 
          --bs-border-color: #ddd;

          color: var(--bs-emphasis-color);
          border-color: var(--bs-border-color) !important;
        }

        table td, table th {
          border-color: var(--bs-border-color) !important;
        }

        .dropdown-menu {
          --bs-dropdown-link-active-bg: #f5f5f5;
          --bs-dropdown-link-active-color: var(--bs-dropdown-link-color);
        }

        ${settings.page && settings.styles.additional ? settings.styles.additional.join('\n') : ''}`
      }</style>
    );

    if (settings.styles.page.fontLink) {
      headElements.push(
        <link key="fontLink" rel="stylesheet" href={settings.styles.page.fontLink}></link>
      );
    }

    // Cookie banner styles (supports multiple providers)
    headElements.push(...getCookieBannerStyles(settings));

    if (settings.page) {
      headElements.push(
        <title key={nodeId()}>{settings.page.title}</title>
      );

      headElements.push(
        <link rel="shortcut icon" key={nodeId()} href={settings.page.favicon} />
      );

      // custom fonts, included statically for now
      // TODO: remove later and import + bundle fonts as part of build pipeline
      if (/Gill Sans/g.test(settings.styles.page.font)) {
        headElements.push(
          <style key={nodeId()}>{
            `@font-face {
              font-family: 'Gill Sans';
              src: url(/fonts/font-gill-sans.woff) format('woff');
            }`
          }</style>
        );
      }

      if (/Cabin/g.test(settings.styles.page.font)) {
        headElements.push(
          <style key={nodeId()}>{
            `@font-face {
              font-family: 'Cabin';
              src: url(/fonts/cabin-regular-webfont.ttf) format('truetype'),
                url('/fonts/cabin-regular-webfont.woff2') format('woff2'),
                url('/fonts/cabin-regular-webfont.woff') format('woff');
            }`
          }</style>
        );
      }

      // TODO: Remove this after S3 bucket permissions are cleared
      if (/SST/g.test(settings.styles.page.font)) {
        headElements.push(
          <style key={nodeId()}>{
            `@font-face {
              font-family: 'SST';
              src: url('/fonts/SST-Roman.ttf') format('truetype');
              font-weight: 400;
              font-style: normal;
            }

            @font-face {
              font-family: 'SST';
              src: url('/fonts/SST-Light.ttf') format('truetype');
              font-weight: 300;
              font-style: normal;
            }

            @font-face {
              font-family: 'SST';
              src: url('/fonts/SST-Medium.ttf') format('truetype');
              font-weight: 500;
              font-style: normal;
            }

            @font-face {
              font-family: 'SST';
              src: url('/fonts/SST-Bold.ttf') format('truetype');
              font-weight: 700;
              font-style: normal;
            }

            @font-face {
              font-family: 'SST';
              src: url('/fonts/SST-Heavy.ttf') format('truetype');
              font-weight: 800;
              font-style: normal;
            }
            `
          }</style>
        );
      }

      //TODO: support multiple custom fonts
      if (/Open Sans/g.test(settings.styles.page.secondFont) || /Open Sans/g.test(settings.styles.page.font)) {
        headElements.push(
          <link key={nodeId()} rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Open+Sans" />
        );
      }
    }

    return (
      <Helmet>
        {headElements}
      </Helmet>
    );
  }

  render() {
    const {
      isProduction,
      isLocal,
      alert
    } = this.state;

    const {
      settings,
      error,
    } = this.props;

    if (!isEmpty(settings) && !error) {
      // Special case reasons to NOT display the website go here.
      if (settings.disabled) {
        return settings.disabledPageMarkdown
          ? <Markdown>
            {settings.disabledPageMarkdown}
          </Markdown>
          : (<h3>This page is temporarily unavailable. We've experienced some technical difficulties and we're sorry for the inconvenience. Please try again later.</h3>);
      } else if (settings.force404) {
        return (NotFoundPage());
      } else {
        const metaWrapper = this.getMetaWrapper(settings, isLocal, isProduction);

        const siteType = settings.siteType && settings.siteType.toUpperCase();
        if (Object.hasOwn(COMPONENT_MAPPING, siteType)) {
          return (
            <TrackingProvider settings={settings}>
              <div>
                {metaWrapper}
                <ToastMessage message={alert} onDismiss={() => this.setState({alert: ''})}/>
                <Switch>
                  {renderRoutes(settings)}
                  <Route component={NotFoundPage} />
                </Switch>
              </div>
            </TrackingProvider>
          );
        } else {
          return (<h3>Unsupported or missing site type.</h3>);
        }
      }
    } else if (error) {
      return <h3>{error}</h3>;
    } else {
      return <Loader/>;
    }

  }
}

const mapStateToProps = function (state) {
  const {
    settings,
  } = state;

  const metaData = settings.get('_metadata');

  return {
    settings: settings.get('settings').toJS(),
    error: metaData.get('error'),
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    dispatchGetSettings: (...args) => {
      dispatch(getSettings(...args, window.env.local));
    },
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AppRoutes));
